import script from "./ClubesAdminView.vue?vue&type=script&setup=true&lang=js"
export * from "./ClubesAdminView.vue?vue&type=script&setup=true&lang=js"

import "./ClubesAdminView.vue?vue&type=style&index=0&id=aef4f1ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aef4f1ae"]])

export default __exports__